import { Component, ViewEncapsulation,Input, Output, EventEmitter, ElementRef, OnInit, NgZone, ViewChild, OnDestroy, ContentChild} from '@angular/core';

import { AuthService } from '../../../app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductViewHelperService } from 'modules/shared-postlogin/services/product-view-helper.service';
import { LoaderService } from '../../../app/services/loader.service';
import { Subscription } from 'rxjs';
import { GigyaSessionService } from '../../../app/services/gigya-session.service';
import { AppHelperService } from '../../../app/services/app-helper.service';
import { ProductTocService } from 'modules/shared-postlogin/services/product-toc.service';
import { ContentHelper } from 'libs-content-helper';
import { CreateAccessRules } from './../create-access-rules/create-access-rules.component';
import { AssignmentViewService } from 'modules/teacher/services/assignment-view.service';
import { MessageService } from 'modules/shared-all/services/message.service';
import { AssignmentPath } from '../assignment-path/assignment-path.component'

@Component({
    selector: 'activity-renderer',
    templateUrl: './activity-renderer.template.html',
    styleUrls: ['./activity-renderer.style.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class ActivityRenderer implements OnInit, OnDestroy {
  contentHelper = ContentHelper;
  selectedItemSubscription: Subscription;
  saveAlertActionOnLogoutSubscription : Subscription;
  showUpdateContentMsgSubscription: Subscription;
  showCloseActivitySubscription: Subscription;
  showSetRulePageSubscription: Subscription;
  subscriptions = new Subscription();
  currentActivityId: string;
  isAssignmentDeleted : boolean = false;
  selectedActivity: any;
  unitIndex: number;
  lessonIndex: number;  
  activityIndex: number;
  tocFolderDepth: number;
  lessonSequence: String;
  @Input() learningpathVisible: boolean;
  @Input() tocArray : any[];
  @Input() ebookAssignmentFlowParams: any;
  @Input() public classmeta: any;
  @Output() learningpathVisibleChange = new EventEmitter<boolean>();
  @Input() hideSequencing : string;
  @Input() createAccessRule: boolean;
  @Input() gradeActivitySelection: boolean;
  @Input() showActivity: boolean;
  @Input() ruleInfo: any;
  @Output() showActivityChange = new EventEmitter<boolean>();
  @Input() itemsAlreadyAssigned: any;
  @Input() productTocData: any;
  @Input() noOfCheckedItems: number;
  @Input() isAssignmentContentUpdated: boolean;
  @Output() noOfCheckedItemsChange = new EventEmitter<number>();
  @Output() showAssignmentLimitWarningModal = new EventEmitter<boolean>();
  @ViewChild('accessRules') accessRulesComponent: CreateAccessRules;
  @ViewChild('editClassDetailsModal') private editClassDetailsModal: ElementRef;
  @ViewChild('closeBtnClassEditModal') private closeBtnClassEditModal: ElementRef;
  @ViewChild('exitConfirmationModalButton') exitConfirmationModalButton: ElementRef;
  @ViewChild('closeExitConfirmationModalButton') exitConfirmationModalCloseButton: ElementRef;
  @ViewChild('exitConfirmationModal') exitConfirmationModal: ElementRef;

  @ContentChild('assignmentPath') assignmentPathComponent: AssignmentPath;

  /* Boolean to show/hide the activity container */
  @Input() showResultScreen: boolean;
  showBanner: boolean = false;
  @Input() ltiDeepLinkingMode: boolean;
  @Input() isEditMode: boolean;
  @Output() tocNavigateBackEvent = new EventEmitter<boolean>();
  tocIcon;
  public showCloseActivityBtn: boolean = false;
  public showUpdateContentsBanner: boolean = false;
  public showSetRulePage: boolean = false;
  // For form binding
  public classFormDetails: any;
  public minEndDatePossible: Date;
  public showSpinner = false;
  public reactivationSuccessData: any;
  public showAssignmentDetailsPage: boolean;
  public imageBasePath: string = IMAGES_BASEPATH;
  public isAssignmentEditMode: boolean = false;

  constructor(private gigyaSessionService: GigyaSessionService,
    private authService: AuthService,
    private loaderService: LoaderService,
    private productViewHelperService: ProductViewHelperService,
    private appHelperService : AppHelperService,
    private productTocService : ProductTocService,
    private assignmentViewService : AssignmentViewService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,
    private ngZone:NgZone ) {}

  ngOnInit() {
    this.tocFolderDepth = this.productTocService.getTocNodeCount(this.tocArray);
    if(this.tocFolderDepth == 0){
      this.hideSequencing = 'true';
    }
    //receiving the assignment deletion status to show the 'assignment deletion success banner' in template
    this.assignmentViewService.deletedAssignmentSubject.subscribe((deletedAssignmentStatus: any) => {
      this.isAssignmentDeleted = deletedAssignmentStatus.customLinkDeleted;
      //removing the 'assignment deletion success banner' in 10sec
      setTimeout(() => {
        this.isAssignmentDeleted = false;
      }, 10000);
    });
    this.selectedItemSubscription = this.productViewHelperService.selectedItemId.subscribe((selectedItemObject: any) => {
      // Added settimeout to fix "Expression has changed after it was checked" error
      setTimeout(() => {
        this.currentActivityId = selectedItemObject?.itemid;
        this.selectedActivity = selectedItemObject?.selectedItemData;
        this.setLessonSequence();
      });
    });

    // receiving the showAssignmentDetailsPage status to show the 'assignment details page' in template
    this.subscriptions.add(
      this.assignmentViewService.assignmentCreationState.subscribe((res) => {
        this.showAssignmentDetailsPage = res.isAssignDetailCompShown;
        this.isAssignmentEditMode = res.isEditMode;

        // Navigate to assignment summary page if the navigateToAssignmentSummaryOrDetailsPage flag is true
        if (res.navigateToAssignmentSummaryOrDetailsPage) {
          this.productViewHelperService.selectedItemId.next(null);
          this.router.navigate(['./'], { relativeTo: this.route });
        }
      })
    );

    // Show Assignment Details page directly if `isEditMode` is true
    if (this.isEditMode) {
      this.showAssignmentDetailsPage = true;
    }
    
    if (this.createAccessRule) {
      this.showAssignmentDetailsPage = false;
    }

    this.tocIcon = this.productTocService.getTOCIconBasedOnTheme();
    this.showBanner = this.route.snapshot.queryParams['showMessageBanner'] === 'true';

    // Event to show activity close btn
    this.showCloseActivitySubscription = this.productViewHelperService.closeActivityBtnSubject.subscribe(data => {
      this.ngZone.run(() => {
        this.showCloseActivityBtn = data.visible;
      });
    });

    //Event to show Updated Contents Banner
    this.showUpdateContentMsgSubscription = this.productViewHelperService.showContentAccessItemsUpdatedMsg.subscribe(data => {
      this.showUpdateContentsBanner = data;
    });

    // Event to set rule page
    this.showSetRulePageSubscription = this.productViewHelperService.showSetRulePageSubject.subscribe(data => {
      this.showSetRulePage = data.isVisible;
      if (this.selectedActivity && !(data.hasOwnProperty('isUpdateView'))) {
        this.closeActivity().catch(e => { throw e; });
      }
    });

    this.subscriptions.add(this.messageService.getChannelObservable('assignment-detail')
      .subscribe((res: any) => {
        if (!this.showAssignmentDetailsPage) this.navigateBack(res.data?.options);
      }));

    this.minEndDatePossible = new Date();
    this.minEndDatePossible.setDate(new Date().getDate() + 1);
    this.minEndDatePossible.setHours(0, 0, 0, 0);
    this.resetForm();
  }

  ngAfterContentInit() {
    /**
     * Subscribe to the event from the assignment-path component, to show the assignment summary confirmation modal.
     * This event is emitted when back button from TOC is clicked.
     */
    if (this.assignmentPathComponent) {
      this.assignmentPathComponent.showAssignmentSummaryWarningModal.subscribe(() => {
        this.triggerAssignmentSummaryConfirmationModal();
      })
    }
  }

  public saveClassChanges(classFormValue) {
    //only send updated data
    const endDate = this.appHelperService.getLastTimeStampForDate(classFormValue.dateGroup.classEndDate);
    const classParams = {
        ...(this.classmeta && this.classmeta.class.enddate != endDate) && { classEndDate: endDate },
    };
    //no params found return
    if (Object.keys(classParams).length === 0) return;

    //spin the spinner
    this.showSpinner = true;
    this.assignmentViewService.editClass(this.classmeta && this.classmeta.uuid, classParams).subscribe(() => {
      //update all class data references
      if (this.classmeta) {
        this.classmeta.class.enddate = endDate;
        this.classmeta.class.isClassEnded = false;
        const updatedClassDetails = {
          endDate: this.classmeta.class.enddate,
          isClassEnded: this.classmeta.class.isClassEnded
        };
        this.assignmentViewService.updateClassDetailsEvent.next(updatedClassDetails);
        this.reactivationSuccessData = {classEndDate: this.classmeta.class.enddate};
        setTimeout(() => {
            this.reactivationSuccessData = null;
        }, 4000);
        this.showSpinner = false;
        //close edit class modal
        this.closeBtnClassEditModal.nativeElement.click();
      }
    });
}

public resetForm() {
  // Setting startDate and endDate
  if (this.classmeta) {
    this.classFormDetails = {
        startDate: new Date(this.classmeta && this.classmeta.class.startdate),
        endDate: new Date(this.classmeta && this.classmeta.class.enddate),
        title: this.classmeta && this.classmeta.title,
    };
  }
}

  setLessonSequence() {
    if(this.hideSequencing !== 'true'){
      let levelSequence = this.selectedActivity?.sequence.split(".");
      levelSequence?.pop();
      this.lessonSequence = levelSequence?.join(".");
    }
  }
  toggleSideBar() {
    this.learningpathVisible = this.learningpathVisible ? false : true;
    this.learningpathVisibleChange.emit(this.learningpathVisible);
  }
  startLoader() {
    this.loaderService.showOverlayLoader();
  }
  navigateBack(options: any = {}) {
    if(this.ltiDeepLinkingMode) {
      let {spaceid, classid} = this.route.snapshot.params;
      let ltik = this.route.snapshot.queryParams['ltik'];
      this.appHelperService.navigateToOnboardingApp(['lti-teacher-dashboard', spaceid, 'class', classid, 'ltik', ltik]);
    } else {
      let userData = this.authService.getUserData();
      this.appHelperService.showLoaderAndNavigateToDashboard(userData, options);
    }
  }

  public goBackToAssignmentSummaryPage() {
    this.assignmentViewService.assignmentCreationState.next({
      isAssignDetailCompShown: true,
      resetToc: true,
      navigateToAssignmentSummaryOrDetailsPage: true
    });
  }

  public triggerAssignmentSummaryConfirmationModal() {
    this.exitConfirmationModalButton.nativeElement.click();
  }

  async tocNavigateBack() {
    if (this.createAccessRule) {
      if (this.selectedActivity) {
        await this.closeActivity();
      }
      this.accessRulesComponent.navigateBack();
      return;
    }
    this.tocNavigateBackEvent.emit(false);
  }

  public editModeNavigateBack() {
    if (this.isEditMode && this.isAssignmentContentUpdated) {
      this.triggerAssignmentSummaryConfirmationModal();
    } else {
      this.goBackToAssignmentSummaryPage();
    }
  }

  logOut() {
    if((this.createAccessRule || this.gradeActivitySelection) && !this.showActivity) {
      this.loaderService.showOverlayLoader();
      this.logoutUser();
    } else {
      if(this.saveAlertActionOnLogoutSubscription) {
        this.saveAlertActionOnLogoutSubscription.unsubscribe();
      }
      //This is done to logout only after handling the save alert popup case
      this.saveAlertActionOnLogoutSubscription = this.productViewHelperService.saveAlertActionOnLogout.subscribe(()=> {
          this.loaderService.showOverlayLoader();
          this.logoutUser();
      })
      //Needed for Activity launch to show alert if needed
      this.productViewHelperService.logOutCalled.next();
    }
  }

  private logoutUser() {
    // Auth Service Logout
    this.authService.logOut().toPromise().then(
      (res) => {
        if (res.success) {
          this.authService.clearUserdata();
          // Gigya Service Logout
          return this.gigyaSessionService.gigyaLogout();
        }
      }
    ).then(() => {
      // On Logout nabvigate to home page
      this.appHelperService.navigateToOnboardingApp(['home']);
    });
  }

  public closeActivity() {
    const {spaceid, classid, productcode} = this.route.snapshot.params;
    const isDownloadableContent = this.selectedActivity && this.contentHelper.isDownloadableContent(this.selectedActivity);
    return this.productViewHelperService.terminateActivityView().then(()=> {
      this.ngZone.run(() => {
        if(isDownloadableContent) {
          this.showCloseActivityBtn = false;
        }
        this.showActivity = false;
        this.showActivityChange.emit(this.showActivity);
      });
      if (this.gradeActivitySelection) {
        return this.router.navigate(['teacher', spaceid, 'class', classid, 'product', productcode, 'grade-activity-selection']);
      } else if(this.ruleInfo) {
        return this.router.navigate(['teacher', spaceid, 'class', classid, 'product', productcode, 'update-access', this.ruleInfo.ruleid]);
      } else {
        return this.router.navigate(['teacher', spaceid, 'class', classid, 'product', productcode, 'create-access']);
      }
    });
  }

  public setNoOfCheckedItems(event) {
    this.noOfCheckedItems = event;
    this.noOfCheckedItemsChange.emit(this.noOfCheckedItems);
  }

  public emitShowAssignmentLimitWarningModal(event: boolean) {
    if (event) {
      this.showAssignmentLimitWarningModal.emit(true);
    }
}

  ngOnDestroy() {
      if (this.editClassDetailsModal && this.editClassDetailsModal.nativeElement.classList.contains('show')) {
        this.closeBtnClassEditModal.nativeElement.click();
      }
      if (this.selectedItemSubscription) {
        this.selectedItemSubscription.unsubscribe();
      }
      if(this.saveAlertActionOnLogoutSubscription) {
        this.saveAlertActionOnLogoutSubscription.unsubscribe();
      }
      if(this.showCloseActivitySubscription) {
        this.showCloseActivitySubscription.unsubscribe();
      }
      if (this.showUpdateContentMsgSubscription) {
        this.showUpdateContentMsgSubscription.unsubscribe();
      }
      if(this.showSetRulePageSubscription) {
        this.showSetRulePageSubscription.unsubscribe();
      }
      if (this.exitConfirmationModal.nativeElement.classList.contains('show')) {
        this.exitConfirmationModalCloseButton.nativeElement.click();
      }
  }
}
